<template>
    <c-dialog ref="dialog" height="350" width="450" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户代码">
                <c-input type="number" name="saas_id" disabled></c-input>
            </c-form-item>
            <c-form-item label="商户名称">
                <c-input name="saas_full_name" maxlength="50" disabled></c-input>
            </c-form-item>
            <c-form-item label="验证码" required :tip="'验证码将发送至商家管理员手机【'+manage_user_phone+'】，请向相关人员索要验证码'">
                <c-input class="flex-grow" type="text" name="verify_code" v-model="verify_code" maxlength="6" :clear="false">
                    <template #append>
                        <a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
                    </template>
                </c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>

export default {

    data() {
        return {
            saas_id: '',
            manage_user_phone: '',
            verify_code: '',
            countdown: false
        }
    },
    computed: {
        countdownText() {
            return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
        }
    },
    mounted() {
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.$refs.form.clear();
            if (data) {
                data.verify_code = '';
                this.$refs.form.set(data);
                this.saas_id = data.saas_id;
                this.manage_user_phone = data.manage_user_phone;
                //填充form表单
                this.$refs.dialog.open({
                    title: '商家【'+data.saas_name+'】绑定通联账号'
                });
            } else {
                this.$message({
                    message: '商家信息异常',  // 提示内容,
                    type: 'fail'
                });
                return false;
            }
        },
        //获取验证码
        getSmscode() {
            if (this.countdown) return;
            if (!this.manage_user_phone) {
                this.$message({
                    message: '系统管理员手机号异常，请联系管理员'
                });
                return;
            }
            //调用发送短信接口
            this.request({
                url: '/allinpay/member/send/verify_code',
                data: {
                    client_saas_id: this.saas_id
                },
                loading: true,
                success: () => {
                    this.$message({
                        message: '验证码已发送'
                    });
                    //60秒后可以重新获取
                    !function loop(s) {
                        this.countdown = s;
                        if (s == 0) return;
                        this._timer = setTimeout(() => {
                            loop.call(this, --s);
                        }, 1000);
                    }.call(this, 60);
                }
            });
        },
        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            if (!this.verify_code || this.verify_code.trim() == ''){
                this.$message({
                    message: '请输入验证码',
                    type: 'warn'
                });
                return;
            }
            this.request({
                url: '/allinpay/member/bind/phone',
                data: {
                    client_saas_id: this.saas_id,
                    verify_code: this.verify_code
                },
                success: data => {
                    next();
                    this.$message({
                        message: '绑定成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    this.$confirm({
                        message: msg,
                        buttonName: '我知道了',
                        cancelButton: false,
                        resolve: () => {
                        }
                    })
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
</style>